import posthog from "posthog-js";

import { sanitizeTtvEvent } from "@/app/(application)/(ttv)/ttv/analytics/sanitizeTtvEvent";
import { toTtvEventPostHogProperties } from "@/app/(application)/(ttv)/ttv/analytics/toTtvEventPostHogProperties";
import { ttvAnalyticsEventRing } from "@/app/(application)/(ttv)/ttv/analytics/ttvAnalyticsEventRing";
import type {
  RecordedTtvAnalyticsEvent,
  TtvAnalyticsEvent,
} from "@/app/(application)/(ttv)/ttv/analytics/types";
import { TTV_ANALYTICS_EVENT_SCHEMA_VERSION } from "@/app/(application)/(ttv)/ttv/analytics/types";

// The single door to PostHog for TTV product analytics — no component calls posthog.capture directly. Unlike ttv_stability (one event name with a phase property), each variant's discriminant IS the PostHog event name, so the funnel reads as distinct events. Subscription plan and billing interval arrive on their own as registered super properties (see PostHogIdentify); they are deliberately not repeated here.
export const captureTtvEvent = (event: TtvAnalyticsEvent): void => {
  // Analytics must not become an editor failure mode — the same contract captureTtvStabilityEvent holds, and no caller ever sees an exception from instrumentation. EVERYTHING is inside the try, the allowlist rebuild and the ring append included: they cannot throw today, but the guarantee is "calling this never breaks the editor", and a guarantee that only covers the last statement is not that guarantee.
  try {
    const record: RecordedTtvAnalyticsEvent = {
      ...sanitizeTtvEvent(event),
      recordedAt: Date.now(),
      schemaVersion: TTV_ANALYTICS_EVENT_SCHEMA_VERSION,
    };
    ttvAnalyticsEventRing.append(record);
    // The local ring stays available when browser capture is missing.
    if (
      typeof window === "undefined" ||
      typeof posthog.capture !== "function"
    ) {
      return;
    }
    posthog.capture(record.event, toTtvEventPostHogProperties(record));
  } catch {
    // Product analytics is best-effort by design.
  }
};
